import { userMockData } from "./mock/userData";

/**
 * Simulasi API Login
 * @param {string} email 
 * @param {string} password 
 * @returns {Promise<Object>}
 */
export const loginAPI = (email, password) => {
  return new Promise((resolve, reject) => {
    // Simulasi delay jaringan 800ms
    setTimeout(() => {
      const user = userMockData.find(
        (u) => u.email === email && u.password === password
      );

      if (user) {
        // Hilangkan password dari response demi keamanan simulasi
        const { password, ...userProfile } = user;
        
        resolve({
          success: true,
          message: "Login successful",
          data: {
            ...userProfile,
            token: `simulated_token_${btoa(user.email)}`
          }
        });
      } else {
        reject({
          success: false,
          message: "Kombinasi Email atau Password salah!"
        });
      }
    }, 800);
  });
};

/**
 * Simulasi API Logout
 */
export const logoutAPI = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ success: true, message: "Logged out successfully" });
    }, 400);
  });
};